export const listaMateriaisLimpeza = [
  { id: 1, nome: 'Desodorizador Ambiental - 500ml - Unidade' },
  { id: 2, nome: 'Desodorizador Sanitário - 30 a 50g - Unidade' },
  { id: 3, nome: 'Dispenser Para Copos(180 a 200ml) - Unidade' },
  { id: 4, nome: 'Dispenser Para Copos(50 a 80ml) - Unidade' },
  { id: 5, nome: 'Dispenser Para Higienizador Em Gel  - Unidade' },
  { id: 6, nome: 'Dispenser Para Papel Higiênico - Unidade' },
  { id: 7, nome: 'Dispenser Para Papel Toalha  - Unidade' },
  { id: 8, nome: 'Dispenser Para Sabonete Líquido - Unidade' },
  { id: 9, nome: 'Esponja - Unidade' },
  { id: 10, nome: 'Inseticida - 300ml - Unidade' },
  { id: 11, nome: 'Pano Multiuso - 30m - Unidade' },
  {
    id: 12,
    nome: 'Papel Higiênico - Rolo 300m - Pacote com 8 - Pacote'
  },
  {
    id: 13,
    nome: 'Papel Higiênico - Rolo 30m - Pacote com 4 - Pacote'
  },
  { id: 14, nome: 'Papel Toalha - 1000 - Fardo' },
  { id: 15, nome: 'Sabonete Líquido - Galão 5L - Galão' }
];
